import { AlertCircle } from 'lucide-react';

export function NoSpaceNotice() {
  return (
    <div className="flex items-start gap-3 rounded-md border border-amber-300/50 bg-amber-50 p-3 text-sm dark:border-amber-500/30 dark:bg-amber-950/30">
      <AlertCircle className="mt-0.5 h-4 w-4 shrink-0 text-amber-600 dark:text-amber-400" />
      <div className="space-y-1 text-amber-900 dark:text-amber-100">
        <p className="font-medium">This item can't be answered yet.</p>
        <p className="text-amber-800/80 dark:text-amber-200/80">
          It was created outside a space. Re-run the agent inside a space to make
          it actionable.
        </p>
      </div>
    </div>
  );
}
